import { OpenAPI } from "simplydo/interfaces";

import { API, APIError } from ".";
import SearchParams from "../searchParams";

export const uploads = (api: API) => ({
  generateFileUploadRequest(
    {
      forType,
      forId,
      name,
      size,
      type,
    }: OpenAPI.GET<"/uploads/file/request">["parameters"]["query"],
    success: (res: OpenAPI.GET<"/uploads/file/request">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    const params = new SearchParams({
      name,
      size: size.toString(),
      type,
      forType,
      forId,
    });
    api.maybeAuthenticatedRequest(
      "GET",
      `/uploads/file/request${params.toSafeString()}`,
      null,
      success,
      fail,
    );
  },
  generateMultiFileUploadRequest(
    files: OpenAPI.POST<"/uploads/file/request/multiple">["requestBody"]["files"],
    success: (
      res: OpenAPI.POST<"/uploads/file/request/multiple">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.maybeAuthenticatedRequest(
      "POST",
      "/uploads/file/request/multiple",
      { files },
      success,
      fail,
    );
  },
  generateVideoUploadRequest(
    {
      forType,
      forId,
      name,
      size,
      type,
    }: OpenAPI.GET<"/uploads/video/request">["parameters"]["query"],
    success: (res: OpenAPI.GET<"/uploads/video/request">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    const params = new SearchParams({
      name,
      size: size.toString(),
      type,
      forType,
      forId,
    });
    api.maybeAuthenticatedRequest(
      "GET",
      `/uploads/video/request${params.toSafeString()}`,
      null,
      success,
      fail,
    );
  },
  oneDriveListDirectory(
    path: string,
    success: (
      res: OpenAPI.GET<"/uploads/onedrive/directory">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/uploads/onedrive/directory?path=${path}`,
      null,
      success,
      fail,
    );
  },
  storeOneDriveFileInS3(
    itemId: string,
    itemName: string,
    forId: string,
    forType: string,
    success: (res: OpenAPI.PUT<"/uploads/onedrive/store">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    const params = new SearchParams({ itemId, itemName, forId, forType });

    api.authenticatedRequest(
      "PUT",
      `/uploads/onedrive/store${params.toSafeString()}`,
      null,
      success,
      fail,
    );
  },
  getFileDownloadCookies(
    params: OpenAPI.GET<"/uploads/download/cookies">["parameters"]["query"],
    success: (
      data: OpenAPI.GET<"/uploads/download/cookies">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.maybeAuthenticatedRequest(
      "GET",
      `/uploads/download/cookies${new SearchParams(params).toSafeString()}`,
      null,
      success,
      fail,
    );
  },
  getDownloadDetails(
    params: OpenAPI.GET<"/uploads/download/details">["parameters"]["query"],
    success: (
      data: OpenAPI.GET<"/uploads/download/details">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.maybeAuthenticatedRequest(
      "GET",
      `/uploads/download/details${new SearchParams(params).toSafeString()}`,
      null,
      success,
      fail,
    );
  },
});
